/**
 * Generated by orval v8.15.0 🍺
 * Do not edit manually.
 * NOFOMO REST API
 * REST API. Stage: development.
 * OpenAPI spec version: 1.37.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  Account,
  AccountCreate,
  AccountEventTicketsGroupedResponse,
  AccountEventTicketsResponse,
  AccountEventsOverview,
  AccountUpdate,
  Address,
  AddressUpsert,
  Addresses,
  Favourite,
  FavouriteInput,
  FavouriteResult,
  FavouriteType,
  FavouritesList,
  GetAccountEventTicketsGroupedParams,
  GetAccountEventTicketsParams,
  GetRetroRedeemUserParams,
  ListFavouritesParams,
  SaudiRewardsBalance,
  SaudiRewardsBalanceVerify,
  SaudiRewardsLink,
  SaudiRewardsRetro,
  SaudiRewardsRetroMatchingOrders,
  SaudiRewardsRetroRedeemUser,
} from '../nofomoRestApi.schemas';

import { restfulRequester } from '../../client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export type deleteAccountResponse204 = {
  data: void;
  status: 204;
};

export type deleteAccountResponse401 = {
  data: void;
  status: 401;
};

export type deleteAccountResponse404 = {
  data: void;
  status: 404;
};

export type deleteAccountResponseSuccess = deleteAccountResponse204 & {
  headers: Headers;
};
export type deleteAccountResponseError = (
  | deleteAccountResponse401
  | deleteAccountResponse404
) & {
  headers: Headers;
};

export type deleteAccountResponse =
  | deleteAccountResponseSuccess
  | deleteAccountResponseError;

export const getDeleteAccountUrl = () => {
  return `/accounts/me`;
};

/**
 * @summary Delete the authenticated account
 */
export const deleteAccount = async (
  options?: RequestInit,
): Promise<deleteAccountResponse> => {
  return restfulRequester<deleteAccountResponse>(getDeleteAccountUrl(), {
    ...options,
    method: 'DELETE',
  });
};

export const getDeleteAccountMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccount>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAccount>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteAccount'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAccount>>,
    void
  > = () => {
    return deleteAccount(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccount>>
>;

export type DeleteAccountMutationError = void;

/**
 * @summary Delete the authenticated account
 */
export const useDeleteAccount = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAccount>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAccount>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteAccountMutationOptions(options), queryClient);
};
export type getAccountResponse200 = {
  data: Account;
  status: 200;
};

export type getAccountResponse401 = {
  data: void;
  status: 401;
};

export type getAccountResponse404 = {
  data: void;
  status: 404;
};

export type getAccountResponseSuccess = getAccountResponse200 & {
  headers: Headers;
};
export type getAccountResponseError = (
  | getAccountResponse401
  | getAccountResponse404
) & {
  headers: Headers;
};

export type getAccountResponse =
  | getAccountResponseSuccess
  | getAccountResponseError;

export const getGetAccountUrl = () => {
  return `/accounts/me`;
};

/**
 * @summary Get the authenticated account
 */
export const getAccount = async (
  options?: RequestInit,
): Promise<getAccountResponse> => {
  return restfulRequester<getAccountResponse>(getGetAccountUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetAccountQueryKey = () => {
  return [`/accounts/me`] as const;
};

export const getGetAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccount>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>
  >;
  request?: SecondParameter<typeof restfulRequester>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccountQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccount>>> = ({
    signal,
  }) => getAccount({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccount>>
>;
export type GetAccountQueryError = void;

export function useGetAccount<
  TData = Awaited<ReturnType<typeof getAccount>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccount>>,
          TError,
          Awaited<ReturnType<typeof getAccount>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccount<
  TData = Awaited<ReturnType<typeof getAccount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccount>>,
          TError,
          Awaited<ReturnType<typeof getAccount>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccount<
  TData = Awaited<ReturnType<typeof getAccount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the authenticated account
 */

export function useGetAccount<
  TData = Awaited<ReturnType<typeof getAccount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAccountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type updateAccountResponse200 = {
  data: Account;
  status: 200;
};

export type updateAccountResponse400 = {
  data: void;
  status: 400;
};

export type updateAccountResponse401 = {
  data: void;
  status: 401;
};

export type updateAccountResponse404 = {
  data: void;
  status: 404;
};

export type updateAccountResponseSuccess = updateAccountResponse200 & {
  headers: Headers;
};
export type updateAccountResponseError = (
  | updateAccountResponse400
  | updateAccountResponse401
  | updateAccountResponse404
) & {
  headers: Headers;
};

export type updateAccountResponse =
  | updateAccountResponseSuccess
  | updateAccountResponseError;

export const getUpdateAccountUrl = () => {
  return `/accounts/me`;
};

/**
 * @summary Update the authenticated account
 */
export const updateAccount = async (
  accountUpdate: AccountUpdate,
  options?: RequestInit,
): Promise<updateAccountResponse> => {
  return restfulRequester<updateAccountResponse>(getUpdateAccountUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(accountUpdate),
  });
};

export const getUpdateAccountMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAccount>>,
    TError,
    { data: AccountUpdate },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAccount>>,
  TError,
  { data: AccountUpdate },
  TContext
> => {
  const mutationKey = ['updateAccount'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAccount>>,
    { data: AccountUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return updateAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAccount>>
>;
export type UpdateAccountMutationBody = AccountUpdate;
export type UpdateAccountMutationError = void;

/**
 * @summary Update the authenticated account
 */
export const useUpdateAccount = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAccount>>,
      TError,
      { data: AccountUpdate },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAccount>>,
  TError,
  { data: AccountUpdate },
  TContext
> => {
  return useMutation(getUpdateAccountMutationOptions(options), queryClient);
};
export type markUnsupportedDeviceResponse204 = {
  data: void;
  status: 204;
};

export type markUnsupportedDeviceResponse401 = {
  data: void;
  status: 401;
};

export type markUnsupportedDeviceResponse404 = {
  data: void;
  status: 404;
};

export type markUnsupportedDeviceResponseSuccess =
  markUnsupportedDeviceResponse204 & {
    headers: Headers;
  };
export type markUnsupportedDeviceResponseError = (
  | markUnsupportedDeviceResponse401
  | markUnsupportedDeviceResponse404
) & {
  headers: Headers;
};

export type markUnsupportedDeviceResponse =
  | markUnsupportedDeviceResponseSuccess
  | markUnsupportedDeviceResponseError;

export const getMarkUnsupportedDeviceUrl = () => {
  return `/accounts/me/unsupported-device`;
};

/**
 * @summary Mark the authenticated account as using an unsupported device
 */
export const markUnsupportedDevice = async (
  options?: RequestInit,
): Promise<markUnsupportedDeviceResponse> => {
  return restfulRequester<markUnsupportedDeviceResponse>(
    getMarkUnsupportedDeviceUrl(),
    {
      ...options,
      method: 'POST',
    },
  );
};

export const getMarkUnsupportedDeviceMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markUnsupportedDevice>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markUnsupportedDevice>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['markUnsupportedDevice'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markUnsupportedDevice>>,
    void
  > = () => {
    return markUnsupportedDevice(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkUnsupportedDeviceMutationResult = NonNullable<
  Awaited<ReturnType<typeof markUnsupportedDevice>>
>;

export type MarkUnsupportedDeviceMutationError = void;

/**
 * @summary Mark the authenticated account as using an unsupported device
 */
export const useMarkUnsupportedDevice = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markUnsupportedDevice>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markUnsupportedDevice>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getMarkUnsupportedDeviceMutationOptions(options),
    queryClient,
  );
};
export type onboardAccountResponse201 = {
  data: Account;
  status: 201;
};

export type onboardAccountResponse400 = {
  data: void;
  status: 400;
};

export type onboardAccountResponse401 = {
  data: void;
  status: 401;
};

export type onboardAccountResponseSuccess = onboardAccountResponse201 & {
  headers: Headers;
};
export type onboardAccountResponseError = (
  | onboardAccountResponse400
  | onboardAccountResponse401
) & {
  headers: Headers;
};

export type onboardAccountResponse =
  | onboardAccountResponseSuccess
  | onboardAccountResponseError;

export const getOnboardAccountUrl = () => {
  return `/accounts`;
};

/**
 * @summary Onboard the authenticated account
 */
export const onboardAccount = async (
  accountCreate: AccountCreate,
  options?: RequestInit,
): Promise<onboardAccountResponse> => {
  return restfulRequester<onboardAccountResponse>(getOnboardAccountUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(accountCreate),
  });
};

export const getOnboardAccountMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof onboardAccount>>,
    TError,
    { data: AccountCreate },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof onboardAccount>>,
  TError,
  { data: AccountCreate },
  TContext
> => {
  const mutationKey = ['onboardAccount'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof onboardAccount>>,
    { data: AccountCreate }
  > = (props) => {
    const { data } = props ?? {};

    return onboardAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OnboardAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof onboardAccount>>
>;
export type OnboardAccountMutationBody = AccountCreate;
export type OnboardAccountMutationError = void;

/**
 * @summary Onboard the authenticated account
 */
export const useOnboardAccount = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof onboardAccount>>,
      TError,
      { data: AccountCreate },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof onboardAccount>>,
  TError,
  { data: AccountCreate },
  TContext
> => {
  return useMutation(getOnboardAccountMutationOptions(options), queryClient);
};
export type getAddressesResponse200 = {
  data: Addresses;
  status: 200;
};

export type getAddressesResponse401 = {
  data: void;
  status: 401;
};

export type getAddressesResponseSuccess = getAddressesResponse200 & {
  headers: Headers;
};
export type getAddressesResponseError = getAddressesResponse401 & {
  headers: Headers;
};

export type getAddressesResponse =
  | getAddressesResponseSuccess
  | getAddressesResponseError;

export const getGetAddressesUrl = () => {
  return `/accounts/me/addresses`;
};

/**
 * @summary List addresses for the authenticated account
 */
export const getAddresses = async (
  options?: RequestInit,
): Promise<getAddressesResponse> => {
  return restfulRequester<getAddressesResponse>(getGetAddressesUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetAddressesQueryKey = () => {
  return [`/accounts/me/addresses`] as const;
};

export const getGetAddressesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAddresses>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>
  >;
  request?: SecondParameter<typeof restfulRequester>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAddressesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddresses>>> = ({
    signal,
  }) => getAddresses({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAddresses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAddressesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAddresses>>
>;
export type GetAddressesQueryError = void;

export function useGetAddresses<
  TData = Awaited<ReturnType<typeof getAddresses>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAddresses>>,
          TError,
          Awaited<ReturnType<typeof getAddresses>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAddresses<
  TData = Awaited<ReturnType<typeof getAddresses>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAddresses>>,
          TError,
          Awaited<ReturnType<typeof getAddresses>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAddresses<
  TData = Awaited<ReturnType<typeof getAddresses>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List addresses for the authenticated account
 */

export function useGetAddresses<
  TData = Awaited<ReturnType<typeof getAddresses>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAddressesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type createAddressResponse201 = {
  data: Address;
  status: 201;
};

export type createAddressResponse400 = {
  data: void;
  status: 400;
};

export type createAddressResponse401 = {
  data: void;
  status: 401;
};

export type createAddressResponseSuccess = createAddressResponse201 & {
  headers: Headers;
};
export type createAddressResponseError = (
  | createAddressResponse400
  | createAddressResponse401
) & {
  headers: Headers;
};

export type createAddressResponse =
  | createAddressResponseSuccess
  | createAddressResponseError;

export const getCreateAddressUrl = () => {
  return `/accounts/me/addresses`;
};

/**
 * @summary Create an address for the authenticated account
 */
export const createAddress = async (
  addressUpsert: AddressUpsert,
  options?: RequestInit,
): Promise<createAddressResponse> => {
  return restfulRequester<createAddressResponse>(getCreateAddressUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addressUpsert),
  });
};

export const getCreateAddressMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAddress>>,
    TError,
    { data: AddressUpsert },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAddress>>,
  TError,
  { data: AddressUpsert },
  TContext
> => {
  const mutationKey = ['createAddress'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAddress>>,
    { data: AddressUpsert }
  > = (props) => {
    const { data } = props ?? {};

    return createAddress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAddress>>
>;
export type CreateAddressMutationBody = AddressUpsert;
export type CreateAddressMutationError = void;

/**
 * @summary Create an address for the authenticated account
 */
export const useCreateAddress = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAddress>>,
      TError,
      { data: AddressUpsert },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAddress>>,
  TError,
  { data: AddressUpsert },
  TContext
> => {
  return useMutation(getCreateAddressMutationOptions(options), queryClient);
};
export type updateAddressResponse200 = {
  data: Address;
  status: 200;
};

export type updateAddressResponse400 = {
  data: void;
  status: 400;
};

export type updateAddressResponse401 = {
  data: void;
  status: 401;
};

export type updateAddressResponse404 = {
  data: void;
  status: 404;
};

export type updateAddressResponseSuccess = updateAddressResponse200 & {
  headers: Headers;
};
export type updateAddressResponseError = (
  | updateAddressResponse400
  | updateAddressResponse401
  | updateAddressResponse404
) & {
  headers: Headers;
};

export type updateAddressResponse =
  | updateAddressResponseSuccess
  | updateAddressResponseError;

export const getUpdateAddressUrl = (id: string) => {
  return `/accounts/me/addresses/${id}`;
};

/**
 * @summary Update an address
 */
export const updateAddress = async (
  id: string,
  addressUpsert: AddressUpsert,
  options?: RequestInit,
): Promise<updateAddressResponse> => {
  return restfulRequester<updateAddressResponse>(getUpdateAddressUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addressUpsert),
  });
};

export const getUpdateAddressMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAddress>>,
    TError,
    { id: string; data: AddressUpsert },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAddress>>,
  TError,
  { id: string; data: AddressUpsert },
  TContext
> => {
  const mutationKey = ['updateAddress'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAddress>>,
    { id: string; data: AddressUpsert }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAddress(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAddress>>
>;
export type UpdateAddressMutationBody = AddressUpsert;
export type UpdateAddressMutationError = void;

/**
 * @summary Update an address
 */
export const useUpdateAddress = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAddress>>,
      TError,
      { id: string; data: AddressUpsert },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAddress>>,
  TError,
  { id: string; data: AddressUpsert },
  TContext
> => {
  return useMutation(getUpdateAddressMutationOptions(options), queryClient);
};
export type deleteAddressResponse204 = {
  data: void;
  status: 204;
};

export type deleteAddressResponse401 = {
  data: void;
  status: 401;
};

export type deleteAddressResponse404 = {
  data: void;
  status: 404;
};

export type deleteAddressResponseSuccess = deleteAddressResponse204 & {
  headers: Headers;
};
export type deleteAddressResponseError = (
  | deleteAddressResponse401
  | deleteAddressResponse404
) & {
  headers: Headers;
};

export type deleteAddressResponse =
  | deleteAddressResponseSuccess
  | deleteAddressResponseError;

export const getDeleteAddressUrl = (id: string) => {
  return `/accounts/me/addresses/${id}`;
};

/**
 * @summary Delete an address
 */
export const deleteAddress = async (
  id: string,
  options?: RequestInit,
): Promise<deleteAddressResponse> => {
  return restfulRequester<deleteAddressResponse>(getDeleteAddressUrl(id), {
    ...options,
    method: 'DELETE',
  });
};

export const getDeleteAddressMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAddress>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAddress>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteAddress'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAddress>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAddress(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAddress>>
>;

export type DeleteAddressMutationError = void;

/**
 * @summary Delete an address
 */
export const useDeleteAddress = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAddress>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAddress>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteAddressMutationOptions(options), queryClient);
};
export type deleteLinkedLoyaltyAccountResponse204 = {
  data: void;
  status: 204;
};

export type deleteLinkedLoyaltyAccountResponse401 = {
  data: void;
  status: 401;
};

export type deleteLinkedLoyaltyAccountResponse404 = {
  data: void;
  status: 404;
};

export type deleteLinkedLoyaltyAccountResponseSuccess =
  deleteLinkedLoyaltyAccountResponse204 & {
    headers: Headers;
  };
export type deleteLinkedLoyaltyAccountResponseError = (
  | deleteLinkedLoyaltyAccountResponse401
  | deleteLinkedLoyaltyAccountResponse404
) & {
  headers: Headers;
};

export type deleteLinkedLoyaltyAccountResponse =
  | deleteLinkedLoyaltyAccountResponseSuccess
  | deleteLinkedLoyaltyAccountResponseError;

export const getDeleteLinkedLoyaltyAccountUrl = () => {
  return `/accounts/me/loyalty/saudi-rewards/link`;
};

/**
 * @summary Unlink the loyalty account
 */
export const deleteLinkedLoyaltyAccount = async (
  options?: RequestInit,
): Promise<deleteLinkedLoyaltyAccountResponse> => {
  return restfulRequester<deleteLinkedLoyaltyAccountResponse>(
    getDeleteLinkedLoyaltyAccountUrl(),
    {
      ...options,
      method: 'DELETE',
    },
  );
};

export const getDeleteLinkedLoyaltyAccountMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLinkedLoyaltyAccount>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLinkedLoyaltyAccount>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteLinkedLoyaltyAccount'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLinkedLoyaltyAccount>>,
    void
  > = () => {
    return deleteLinkedLoyaltyAccount(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLinkedLoyaltyAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLinkedLoyaltyAccount>>
>;

export type DeleteLinkedLoyaltyAccountMutationError = void;

/**
 * @summary Unlink the loyalty account
 */
export const useDeleteLinkedLoyaltyAccount = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteLinkedLoyaltyAccount>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteLinkedLoyaltyAccount>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getDeleteLinkedLoyaltyAccountMutationOptions(options),
    queryClient,
  );
};
export type linkLoyaltyAccountResponse200 = {
  data: SaudiRewardsBalance;
  status: 200;
};

export type linkLoyaltyAccountResponse400 = {
  data: void;
  status: 400;
};

export type linkLoyaltyAccountResponse401 = {
  data: void;
  status: 401;
};

export type linkLoyaltyAccountResponseSuccess =
  linkLoyaltyAccountResponse200 & {
    headers: Headers;
  };
export type linkLoyaltyAccountResponseError = (
  | linkLoyaltyAccountResponse400
  | linkLoyaltyAccountResponse401
) & {
  headers: Headers;
};

export type linkLoyaltyAccountResponse =
  | linkLoyaltyAccountResponseSuccess
  | linkLoyaltyAccountResponseError;

export const getLinkLoyaltyAccountUrl = () => {
  return `/accounts/me/loyalty/saudi-rewards/link`;
};

/**
 * @summary Link a Saudi Rewards loyalty account
 */
export const linkLoyaltyAccount = async (
  saudiRewardsLink: SaudiRewardsLink,
  options?: RequestInit,
): Promise<linkLoyaltyAccountResponse> => {
  return restfulRequester<linkLoyaltyAccountResponse>(
    getLinkLoyaltyAccountUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(saudiRewardsLink),
    },
  );
};

export const getLinkLoyaltyAccountMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof linkLoyaltyAccount>>,
    TError,
    { data: SaudiRewardsLink },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof linkLoyaltyAccount>>,
  TError,
  { data: SaudiRewardsLink },
  TContext
> => {
  const mutationKey = ['linkLoyaltyAccount'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof linkLoyaltyAccount>>,
    { data: SaudiRewardsLink }
  > = (props) => {
    const { data } = props ?? {};

    return linkLoyaltyAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LinkLoyaltyAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof linkLoyaltyAccount>>
>;
export type LinkLoyaltyAccountMutationBody = SaudiRewardsLink;
export type LinkLoyaltyAccountMutationError = void;

/**
 * @summary Link a Saudi Rewards loyalty account
 */
export const useLinkLoyaltyAccount = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof linkLoyaltyAccount>>,
      TError,
      { data: SaudiRewardsLink },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof linkLoyaltyAccount>>,
  TError,
  { data: SaudiRewardsLink },
  TContext
> => {
  return useMutation(
    getLinkLoyaltyAccountMutationOptions(options),
    queryClient,
  );
};
export type getLoyaltyBalanceResponse200 = {
  data: SaudiRewardsBalance;
  status: 200;
};

export type getLoyaltyBalanceResponse400 = {
  data: void;
  status: 400;
};

export type getLoyaltyBalanceResponse401 = {
  data: void;
  status: 401;
};

export type getLoyaltyBalanceResponse404 = {
  data: void;
  status: 404;
};

export type getLoyaltyBalanceResponseSuccess = getLoyaltyBalanceResponse200 & {
  headers: Headers;
};
export type getLoyaltyBalanceResponseError = (
  | getLoyaltyBalanceResponse400
  | getLoyaltyBalanceResponse401
  | getLoyaltyBalanceResponse404
) & {
  headers: Headers;
};

export type getLoyaltyBalanceResponse =
  | getLoyaltyBalanceResponseSuccess
  | getLoyaltyBalanceResponseError;

export const getGetLoyaltyBalanceUrl = () => {
  return `/accounts/me/loyalty/saudi-rewards/balance`;
};

/**
 * @summary Get the loyalty balance for the authenticated account
 */
export const getLoyaltyBalance = async (
  saudiRewardsBalanceVerify: SaudiRewardsBalanceVerify,
  options?: RequestInit,
): Promise<getLoyaltyBalanceResponse> => {
  return restfulRequester<getLoyaltyBalanceResponse>(
    getGetLoyaltyBalanceUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(saudiRewardsBalanceVerify),
    },
  );
};

export const getGetLoyaltyBalanceMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getLoyaltyBalance>>,
    TError,
    { data: SaudiRewardsBalanceVerify },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getLoyaltyBalance>>,
  TError,
  { data: SaudiRewardsBalanceVerify },
  TContext
> => {
  const mutationKey = ['getLoyaltyBalance'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getLoyaltyBalance>>,
    { data: SaudiRewardsBalanceVerify }
  > = (props) => {
    const { data } = props ?? {};

    return getLoyaltyBalance(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetLoyaltyBalanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof getLoyaltyBalance>>
>;
export type GetLoyaltyBalanceMutationBody = SaudiRewardsBalanceVerify;
export type GetLoyaltyBalanceMutationError = void;

/**
 * @summary Get the loyalty balance for the authenticated account
 */
export const useGetLoyaltyBalance = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getLoyaltyBalance>>,
      TError,
      { data: SaudiRewardsBalanceVerify },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getLoyaltyBalance>>,
  TError,
  { data: SaudiRewardsBalanceVerify },
  TContext
> => {
  return useMutation(getGetLoyaltyBalanceMutationOptions(options), queryClient);
};
export type getRetroRedeemOrdersResponse200 = {
  data: SaudiRewardsRetroMatchingOrders;
  status: 200;
};

export type getRetroRedeemOrdersResponse401 = {
  data: void;
  status: 401;
};

export type getRetroRedeemOrdersResponseSuccess =
  getRetroRedeemOrdersResponse200 & {
    headers: Headers;
  };
export type getRetroRedeemOrdersResponseError =
  getRetroRedeemOrdersResponse401 & {
    headers: Headers;
  };

export type getRetroRedeemOrdersResponse =
  | getRetroRedeemOrdersResponseSuccess
  | getRetroRedeemOrdersResponseError;

export const getGetRetroRedeemOrdersUrl = () => {
  return `/accounts/me/loyalty/saudi-rewards/retro-redeem/orders`;
};

/**
 * @summary List Saudi Rewards retro-redeem matching orders
 */
export const getRetroRedeemOrders = async (
  options?: RequestInit,
): Promise<getRetroRedeemOrdersResponse> => {
  return restfulRequester<getRetroRedeemOrdersResponse>(
    getGetRetroRedeemOrdersUrl(),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetRetroRedeemOrdersQueryKey = () => {
  return [`/accounts/me/loyalty/saudi-rewards/retro-redeem/orders`] as const;
};

export const getGetRetroRedeemOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getRetroRedeemOrders>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRetroRedeemOrders>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restfulRequester>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRetroRedeemOrdersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRetroRedeemOrders>>
  > = ({ signal }) => getRetroRedeemOrders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRetroRedeemOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRetroRedeemOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRetroRedeemOrders>>
>;
export type GetRetroRedeemOrdersQueryError = void;

export function useGetRetroRedeemOrders<
  TData = Awaited<ReturnType<typeof getRetroRedeemOrders>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetroRedeemOrders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetroRedeemOrders>>,
          TError,
          Awaited<ReturnType<typeof getRetroRedeemOrders>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRetroRedeemOrders<
  TData = Awaited<ReturnType<typeof getRetroRedeemOrders>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetroRedeemOrders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetroRedeemOrders>>,
          TError,
          Awaited<ReturnType<typeof getRetroRedeemOrders>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRetroRedeemOrders<
  TData = Awaited<ReturnType<typeof getRetroRedeemOrders>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetroRedeemOrders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Saudi Rewards retro-redeem matching orders
 */

export function useGetRetroRedeemOrders<
  TData = Awaited<ReturnType<typeof getRetroRedeemOrders>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetroRedeemOrders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRetroRedeemOrdersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getRetroRedeemUserResponse200 = {
  data: SaudiRewardsRetroRedeemUser;
  status: 200;
};

export type getRetroRedeemUserResponse400 = {
  data: void;
  status: 400;
};

export type getRetroRedeemUserResponse401 = {
  data: void;
  status: 401;
};

export type getRetroRedeemUserResponse404 = {
  data: void;
  status: 404;
};

export type getRetroRedeemUserResponseSuccess =
  getRetroRedeemUserResponse200 & {
    headers: Headers;
  };
export type getRetroRedeemUserResponseError = (
  | getRetroRedeemUserResponse400
  | getRetroRedeemUserResponse401
  | getRetroRedeemUserResponse404
) & {
  headers: Headers;
};

export type getRetroRedeemUserResponse =
  | getRetroRedeemUserResponseSuccess
  | getRetroRedeemUserResponseError;

export const getGetRetroRedeemUserUrl = (params: GetRetroRedeemUserParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/accounts/loyalty/saudi-rewards/retro-redeem/user?${stringifiedParams}`
    : `/accounts/loyalty/saudi-rewards/retro-redeem/user`;
};

/**
 * @summary Look up a Saudi Rewards retro-redeem user by token
 */
export const getRetroRedeemUser = async (
  params: GetRetroRedeemUserParams,
  options?: RequestInit,
): Promise<getRetroRedeemUserResponse> => {
  return restfulRequester<getRetroRedeemUserResponse>(
    getGetRetroRedeemUserUrl(params),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetRetroRedeemUserQueryKey = (
  params?: GetRetroRedeemUserParams,
) => {
  return [
    `/accounts/loyalty/saudi-rewards/retro-redeem/user`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRetroRedeemUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getRetroRedeemUser>>,
  TError = void,
>(
  params: GetRetroRedeemUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetroRedeemUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRetroRedeemUserQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRetroRedeemUser>>
  > = ({ signal }) => getRetroRedeemUser(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRetroRedeemUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRetroRedeemUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRetroRedeemUser>>
>;
export type GetRetroRedeemUserQueryError = void;

export function useGetRetroRedeemUser<
  TData = Awaited<ReturnType<typeof getRetroRedeemUser>>,
  TError = void,
>(
  params: GetRetroRedeemUserParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetroRedeemUser>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetroRedeemUser>>,
          TError,
          Awaited<ReturnType<typeof getRetroRedeemUser>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRetroRedeemUser<
  TData = Awaited<ReturnType<typeof getRetroRedeemUser>>,
  TError = void,
>(
  params: GetRetroRedeemUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetroRedeemUser>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetroRedeemUser>>,
          TError,
          Awaited<ReturnType<typeof getRetroRedeemUser>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRetroRedeemUser<
  TData = Awaited<ReturnType<typeof getRetroRedeemUser>>,
  TError = void,
>(
  params: GetRetroRedeemUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetroRedeemUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Look up a Saudi Rewards retro-redeem user by token
 */

export function useGetRetroRedeemUser<
  TData = Awaited<ReturnType<typeof getRetroRedeemUser>>,
  TError = void,
>(
  params: GetRetroRedeemUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRetroRedeemUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRetroRedeemUserQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type retroRedeemResponse204 = {
  data: void;
  status: 204;
};

export type retroRedeemResponse400 = {
  data: void;
  status: 400;
};

export type retroRedeemResponse401 = {
  data: void;
  status: 401;
};

export type retroRedeemResponse404 = {
  data: void;
  status: 404;
};

export type retroRedeemResponseSuccess = retroRedeemResponse204 & {
  headers: Headers;
};
export type retroRedeemResponseError = (
  | retroRedeemResponse400
  | retroRedeemResponse401
  | retroRedeemResponse404
) & {
  headers: Headers;
};

export type retroRedeemResponse =
  | retroRedeemResponseSuccess
  | retroRedeemResponseError;

export const getRetroRedeemUrl = () => {
  return `/accounts/me/loyalty/saudi-rewards/retro-redeem`;
};

/**
 * @summary Redeem Saudi Rewards retro points
 */
export const retroRedeem = async (
  saudiRewardsRetro: SaudiRewardsRetro,
  options?: RequestInit,
): Promise<retroRedeemResponse> => {
  return restfulRequester<retroRedeemResponse>(getRetroRedeemUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saudiRewardsRetro),
  });
};

export const getRetroRedeemMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retroRedeem>>,
    TError,
    { data: SaudiRewardsRetro },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retroRedeem>>,
  TError,
  { data: SaudiRewardsRetro },
  TContext
> => {
  const mutationKey = ['retroRedeem'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retroRedeem>>,
    { data: SaudiRewardsRetro }
  > = (props) => {
    const { data } = props ?? {};

    return retroRedeem(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetroRedeemMutationResult = NonNullable<
  Awaited<ReturnType<typeof retroRedeem>>
>;
export type RetroRedeemMutationBody = SaudiRewardsRetro;
export type RetroRedeemMutationError = void;

/**
 * @summary Redeem Saudi Rewards retro points
 */
export const useRetroRedeem = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof retroRedeem>>,
      TError,
      { data: SaudiRewardsRetro },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof retroRedeem>>,
  TError,
  { data: SaudiRewardsRetro },
  TContext
> => {
  return useMutation(getRetroRedeemMutationOptions(options), queryClient);
};
export type getAccountEventsOverviewResponse200 = {
  data: AccountEventsOverview;
  status: 200;
};

export type getAccountEventsOverviewResponse401 = {
  data: void;
  status: 401;
};

export type getAccountEventsOverviewResponseSuccess =
  getAccountEventsOverviewResponse200 & {
    headers: Headers;
  };
export type getAccountEventsOverviewResponseError =
  getAccountEventsOverviewResponse401 & {
    headers: Headers;
  };

export type getAccountEventsOverviewResponse =
  | getAccountEventsOverviewResponseSuccess
  | getAccountEventsOverviewResponseError;

export const getGetAccountEventsOverviewUrl = () => {
  return `/accounts/me/events`;
};

/**
 * @summary List events the authenticated account has tickets for
 */
export const getAccountEventsOverview = async (
  options?: RequestInit,
): Promise<getAccountEventsOverviewResponse> => {
  return restfulRequester<getAccountEventsOverviewResponse>(
    getGetAccountEventsOverviewUrl(),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetAccountEventsOverviewQueryKey = () => {
  return [`/accounts/me/events`] as const;
};

export const getGetAccountEventsOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountEventsOverview>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAccountEventsOverview>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restfulRequester>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAccountEventsOverviewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountEventsOverview>>
  > = ({ signal }) => getAccountEventsOverview({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountEventsOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAccountEventsOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountEventsOverview>>
>;
export type GetAccountEventsOverviewQueryError = void;

export function useGetAccountEventsOverview<
  TData = Awaited<ReturnType<typeof getAccountEventsOverview>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountEventsOverview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountEventsOverview>>,
          TError,
          Awaited<ReturnType<typeof getAccountEventsOverview>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccountEventsOverview<
  TData = Awaited<ReturnType<typeof getAccountEventsOverview>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountEventsOverview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountEventsOverview>>,
          TError,
          Awaited<ReturnType<typeof getAccountEventsOverview>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccountEventsOverview<
  TData = Awaited<ReturnType<typeof getAccountEventsOverview>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountEventsOverview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List events the authenticated account has tickets for
 */

export function useGetAccountEventsOverview<
  TData = Awaited<ReturnType<typeof getAccountEventsOverview>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountEventsOverview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAccountEventsOverviewQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getAccountEventTicketsResponse200 = {
  data: AccountEventTicketsResponse;
  status: 200;
};

export type getAccountEventTicketsResponse401 = {
  data: void;
  status: 401;
};

export type getAccountEventTicketsResponseSuccess =
  getAccountEventTicketsResponse200 & {
    headers: Headers;
  };
export type getAccountEventTicketsResponseError =
  getAccountEventTicketsResponse401 & {
    headers: Headers;
  };

export type getAccountEventTicketsResponse =
  | getAccountEventTicketsResponseSuccess
  | getAccountEventTicketsResponseError;

export const getGetAccountEventTicketsUrl = (
  id: string,
  params?: GetAccountEventTicketsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/accounts/me/events/${id}/tickets?${stringifiedParams}`
    : `/accounts/me/events/${id}/tickets`;
};

/**
 * @summary List the account tickets for an event (paginated when page+pageSize are set)
 */
export const getAccountEventTickets = async (
  id: string,
  params?: GetAccountEventTicketsParams,
  options?: RequestInit,
): Promise<getAccountEventTicketsResponse> => {
  return restfulRequester<getAccountEventTicketsResponse>(
    getGetAccountEventTicketsUrl(id, params),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetAccountEventTicketsQueryKey = (
  id: string,
  params?: GetAccountEventTicketsParams,
) => {
  return [
    `/accounts/me/events/${id}/tickets`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAccountEventTicketsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountEventTickets>>,
  TError = void,
>(
  id: string,
  params?: GetAccountEventTicketsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountEventTickets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAccountEventTicketsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountEventTickets>>
  > = ({ signal }) =>
    getAccountEventTickets(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountEventTickets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAccountEventTicketsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountEventTickets>>
>;
export type GetAccountEventTicketsQueryError = void;

export function useGetAccountEventTickets<
  TData = Awaited<ReturnType<typeof getAccountEventTickets>>,
  TError = void,
>(
  id: string,
  params: undefined | GetAccountEventTicketsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountEventTickets>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountEventTickets>>,
          TError,
          Awaited<ReturnType<typeof getAccountEventTickets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccountEventTickets<
  TData = Awaited<ReturnType<typeof getAccountEventTickets>>,
  TError = void,
>(
  id: string,
  params?: GetAccountEventTicketsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountEventTickets>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountEventTickets>>,
          TError,
          Awaited<ReturnType<typeof getAccountEventTickets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccountEventTickets<
  TData = Awaited<ReturnType<typeof getAccountEventTickets>>,
  TError = void,
>(
  id: string,
  params?: GetAccountEventTicketsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountEventTickets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List the account tickets for an event (paginated when page+pageSize are set)
 */

export function useGetAccountEventTickets<
  TData = Awaited<ReturnType<typeof getAccountEventTickets>>,
  TError = void,
>(
  id: string,
  params?: GetAccountEventTicketsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountEventTickets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAccountEventTicketsQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getAccountEventTicketsGroupedResponse200 = {
  data: AccountEventTicketsGroupedResponse;
  status: 200;
};

export type getAccountEventTicketsGroupedResponse401 = {
  data: void;
  status: 401;
};

export type getAccountEventTicketsGroupedResponseSuccess =
  getAccountEventTicketsGroupedResponse200 & {
    headers: Headers;
  };
export type getAccountEventTicketsGroupedResponseError =
  getAccountEventTicketsGroupedResponse401 & {
    headers: Headers;
  };

export type getAccountEventTicketsGroupedResponse =
  | getAccountEventTicketsGroupedResponseSuccess
  | getAccountEventTicketsGroupedResponseError;

export const getGetAccountEventTicketsGroupedUrl = (
  id: string,
  params?: GetAccountEventTicketsGroupedParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/accounts/me/events/${id}/tickets/grouped?${stringifiedParams}`
    : `/accounts/me/events/${id}/tickets/grouped`;
};

/**
 * @summary List the account tickets for an event, grouped by parent ticket (paginated when page+pageSize are set)
 */
export const getAccountEventTicketsGrouped = async (
  id: string,
  params?: GetAccountEventTicketsGroupedParams,
  options?: RequestInit,
): Promise<getAccountEventTicketsGroupedResponse> => {
  return restfulRequester<getAccountEventTicketsGroupedResponse>(
    getGetAccountEventTicketsGroupedUrl(id, params),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetAccountEventTicketsGroupedQueryKey = (
  id: string,
  params?: GetAccountEventTicketsGroupedParams,
) => {
  return [
    `/accounts/me/events/${id}/tickets/grouped`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAccountEventTicketsGroupedQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>,
  TError = void,
>(
  id: string,
  params?: GetAccountEventTicketsGroupedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAccountEventTicketsGroupedQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>
  > = ({ signal }) =>
    getAccountEventTicketsGrouped(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAccountEventTicketsGroupedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>
>;
export type GetAccountEventTicketsGroupedQueryError = void;

export function useGetAccountEventTicketsGrouped<
  TData = Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>,
  TError = void,
>(
  id: string,
  params: undefined | GetAccountEventTicketsGroupedParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>,
          TError,
          Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccountEventTicketsGrouped<
  TData = Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>,
  TError = void,
>(
  id: string,
  params?: GetAccountEventTicketsGroupedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>,
          TError,
          Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccountEventTicketsGrouped<
  TData = Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>,
  TError = void,
>(
  id: string,
  params?: GetAccountEventTicketsGroupedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List the account tickets for an event, grouped by parent ticket (paginated when page+pageSize are set)
 */

export function useGetAccountEventTicketsGrouped<
  TData = Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>,
  TError = void,
>(
  id: string,
  params?: GetAccountEventTicketsGroupedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountEventTicketsGrouped>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAccountEventTicketsGroupedQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type addFavouriteResponse201 = {
  data: Favourite;
  status: 201;
};

export type addFavouriteResponse400 = {
  data: void;
  status: 400;
};

export type addFavouriteResponse401 = {
  data: void;
  status: 401;
};

export type addFavouriteResponse404 = {
  data: void;
  status: 404;
};

export type addFavouriteResponseSuccess = addFavouriteResponse201 & {
  headers: Headers;
};
export type addFavouriteResponseError = (
  | addFavouriteResponse400
  | addFavouriteResponse401
  | addFavouriteResponse404
) & {
  headers: Headers;
};

export type addFavouriteResponse =
  | addFavouriteResponseSuccess
  | addFavouriteResponseError;

export const getAddFavouriteUrl = () => {
  return `/accounts/me/favourites`;
};

/**
 * @summary Save a favourite artist or event
 */
export const addFavourite = async (
  favouriteInput: FavouriteInput,
  options?: RequestInit,
): Promise<addFavouriteResponse> => {
  return restfulRequester<addFavouriteResponse>(getAddFavouriteUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(favouriteInput),
  });
};

export const getAddFavouriteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addFavourite>>,
    TError,
    { data: FavouriteInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addFavourite>>,
  TError,
  { data: FavouriteInput },
  TContext
> => {
  const mutationKey = ['addFavourite'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addFavourite>>,
    { data: FavouriteInput }
  > = (props) => {
    const { data } = props ?? {};

    return addFavourite(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddFavouriteMutationResult = NonNullable<
  Awaited<ReturnType<typeof addFavourite>>
>;
export type AddFavouriteMutationBody = FavouriteInput;
export type AddFavouriteMutationError = void;

/**
 * @summary Save a favourite artist or event
 */
export const useAddFavourite = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addFavourite>>,
      TError,
      { data: FavouriteInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addFavourite>>,
  TError,
  { data: FavouriteInput },
  TContext
> => {
  return useMutation(getAddFavouriteMutationOptions(options), queryClient);
};
export type listFavouritesResponse200 = {
  data: FavouritesList;
  status: 200;
};

export type listFavouritesResponse401 = {
  data: void;
  status: 401;
};

export type listFavouritesResponseSuccess = listFavouritesResponse200 & {
  headers: Headers;
};
export type listFavouritesResponseError = listFavouritesResponse401 & {
  headers: Headers;
};

export type listFavouritesResponse =
  | listFavouritesResponseSuccess
  | listFavouritesResponseError;

export const getListFavouritesUrl = (params?: ListFavouritesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/accounts/me/favourites?${stringifiedParams}`
    : `/accounts/me/favourites`;
};

/**
 * @summary List the authenticated user's favourites
 */
export const listFavourites = async (
  params?: ListFavouritesParams,
  options?: RequestInit,
): Promise<listFavouritesResponse> => {
  return restfulRequester<listFavouritesResponse>(
    getListFavouritesUrl(params),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getListFavouritesQueryKey = (params?: ListFavouritesParams) => {
  return [`/accounts/me/favourites`, ...(params ? [params] : [])] as const;
};

export const getListFavouritesQueryOptions = <
  TData = Awaited<ReturnType<typeof listFavourites>>,
  TError = void,
>(
  params?: ListFavouritesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFavourites>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFavouritesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFavourites>>> = ({
    signal,
  }) => listFavourites(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFavourites>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListFavouritesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFavourites>>
>;
export type ListFavouritesQueryError = void;

export function useListFavourites<
  TData = Awaited<ReturnType<typeof listFavourites>>,
  TError = void,
>(
  params: undefined | ListFavouritesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFavourites>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFavourites>>,
          TError,
          Awaited<ReturnType<typeof listFavourites>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListFavourites<
  TData = Awaited<ReturnType<typeof listFavourites>>,
  TError = void,
>(
  params?: ListFavouritesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFavourites>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFavourites>>,
          TError,
          Awaited<ReturnType<typeof listFavourites>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListFavourites<
  TData = Awaited<ReturnType<typeof listFavourites>>,
  TError = void,
>(
  params?: ListFavouritesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFavourites>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List the authenticated user's favourites
 */

export function useListFavourites<
  TData = Awaited<ReturnType<typeof listFavourites>>,
  TError = void,
>(
  params?: ListFavouritesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFavourites>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListFavouritesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getFavouriteResponse200 = {
  data: FavouriteResult;
  status: 200;
};

export type getFavouriteResponse401 = {
  data: void;
  status: 401;
};

export type getFavouriteResponseSuccess = getFavouriteResponse200 & {
  headers: Headers;
};
export type getFavouriteResponseError = getFavouriteResponse401 & {
  headers: Headers;
};

export type getFavouriteResponse =
  | getFavouriteResponseSuccess
  | getFavouriteResponseError;

export const getGetFavouriteUrl = (type: FavouriteType, value: string) => {
  return `/accounts/me/favourites/${type}/${value}`;
};

/**
 * @summary Get a single favourite (artist or event), or null when not set
 */
export const getFavourite = async (
  type: FavouriteType,
  value: string,
  options?: RequestInit,
): Promise<getFavouriteResponse> => {
  return restfulRequester<getFavouriteResponse>(
    getGetFavouriteUrl(type, value),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetFavouriteQueryKey = (type: FavouriteType, value: string) => {
  return [`/accounts/me/favourites/${type}/${value}`] as const;
};

export const getGetFavouriteQueryOptions = <
  TData = Awaited<ReturnType<typeof getFavourite>>,
  TError = void,
>(
  type: FavouriteType,
  value: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFavourite>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFavouriteQueryKey(type, value);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFavourite>>> = ({
    signal,
  }) => getFavourite(type, value, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      type !== null &&
      type !== undefined &&
      value !== null &&
      value !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFavourite>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFavouriteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFavourite>>
>;
export type GetFavouriteQueryError = void;

export function useGetFavourite<
  TData = Awaited<ReturnType<typeof getFavourite>>,
  TError = void,
>(
  type: FavouriteType,
  value: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFavourite>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFavourite>>,
          TError,
          Awaited<ReturnType<typeof getFavourite>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFavourite<
  TData = Awaited<ReturnType<typeof getFavourite>>,
  TError = void,
>(
  type: FavouriteType,
  value: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFavourite>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFavourite>>,
          TError,
          Awaited<ReturnType<typeof getFavourite>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFavourite<
  TData = Awaited<ReturnType<typeof getFavourite>>,
  TError = void,
>(
  type: FavouriteType,
  value: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFavourite>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single favourite (artist or event), or null when not set
 */

export function useGetFavourite<
  TData = Awaited<ReturnType<typeof getFavourite>>,
  TError = void,
>(
  type: FavouriteType,
  value: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFavourite>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFavouriteQueryOptions(type, value, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type removeFavouriteResponse204 = {
  data: void;
  status: 204;
};

export type removeFavouriteResponse400 = {
  data: void;
  status: 400;
};

export type removeFavouriteResponse401 = {
  data: void;
  status: 401;
};

export type removeFavouriteResponseSuccess = removeFavouriteResponse204 & {
  headers: Headers;
};
export type removeFavouriteResponseError = (
  | removeFavouriteResponse400
  | removeFavouriteResponse401
) & {
  headers: Headers;
};

export type removeFavouriteResponse =
  | removeFavouriteResponseSuccess
  | removeFavouriteResponseError;

export const getRemoveFavouriteUrl = (type: FavouriteType, value: string) => {
  return `/accounts/me/favourites/${type}/${value}`;
};

/**
 * @summary Remove a favourite artist or event
 */
export const removeFavourite = async (
  type: FavouriteType,
  value: string,
  options?: RequestInit,
): Promise<removeFavouriteResponse> => {
  return restfulRequester<removeFavouriteResponse>(
    getRemoveFavouriteUrl(type, value),
    {
      ...options,
      method: 'DELETE',
    },
  );
};

export const getRemoveFavouriteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeFavourite>>,
    TError,
    { type: FavouriteType; value: string },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeFavourite>>,
  TError,
  { type: FavouriteType; value: string },
  TContext
> => {
  const mutationKey = ['removeFavourite'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeFavourite>>,
    { type: FavouriteType; value: string }
  > = (props) => {
    const { type, value } = props ?? {};

    return removeFavourite(type, value, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveFavouriteMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeFavourite>>
>;

export type RemoveFavouriteMutationError = void;

/**
 * @summary Remove a favourite artist or event
 */
export const useRemoveFavourite = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeFavourite>>,
      TError,
      { type: FavouriteType; value: string },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeFavourite>>,
  TError,
  { type: FavouriteType; value: string },
  TContext
> => {
  return useMutation(getRemoveFavouriteMutationOptions(options), queryClient);
};
